// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBox_container__sMpbQ","icon":"SearchBox_icon__1bySn","input":"SearchBox_input__rTRPu","error":"SearchBox_error__fJDHp","button":"SearchBox_button__3si6-"};